import { motion } from "framer-motion";
import "../../asstes/styles/finalWordSection.scss";
import whyBhupendra from "../../asstes/images/private-council/why-bhupendra.jpg";
import Final_Words_Banner from "../../asstes/images/private-council/final-words.jpg";
const FinalWordSection = () => {
    return (
        <section className="final-word-section elegant-v2"> 
            

           

            <div className="container">

                <div className="row align-items-center gy-5">

                    {/* LEFT CONTENT */}
                    <div className="col-lg-7">

                        <motion.div
                            initial={{ opacity: 0, x: -80 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 1 }}
                            viewport={{ once: true }}
                            className="content-wrapper"
                        >

                            {/* TAG */}
                            <div className="section-tag">
                                <span></span>
                                THE FINAL WORD
                            </div>

                            {/* TITLE */}
                            <motion.h2
                                initial={{ opacity: 0, y: 60 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1.2 }}
                                viewport={{ once: true }}
                                className="main-title"
                            >
                                When consequence <br/>can no
                                <span> longer be <br/>postponed</span>
                            </motion.h2>

                            {/* DESCRIPTION */}
                            <motion.p
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.2 }}
                                viewport={{ once: true }}
                                className="description"
                            >
                                If the description of the Private Council
                                meets the condition of your situation,
                                you may submit a Private Alignment Review.
                            </motion.p>

                            {/* BUTTON */}
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.4 }}
                                viewport={{ once: true }}
                                className="button-wrapper"
                            >
                                <div className="hero-buttons btn-toolbar">
                                    <button class="pc-cta btn bh-btn-light view-all">Submit Private Alignment Review</button>
                                </div> 
                            </motion.div>

                        </motion.div>

                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="col-lg-5">

                        <motion.div
                            initial={{ opacity: 0, scale: 0.7, x: 100 }}
                            whileInView={{ opacity: 1, scale: 1, x: 0 }}
                            transition={{ duration: 1.2 }}
                            viewport={{ once: true }}
                            className="final-image-wrapper"
                        >

                            <div className="image-border"></div>

                            <motion.img
                                whileHover={{
                                    scale: 1.05
                                }}
                                transition={{
                                    duration: 0.6
                                }}
                                src={whyBhupendra}
                                alt="Private Council"
                                className="main-image"
                            />

                            

                            <div className="circle-glow"></div>

                        </motion.div>

                    </div>

                </div>

            </div>

        </section>
    );
};

export default FinalWordSection;